import { useContext, useEffect, useState } from "react";
import { ToolContext } from "../../../../../../core/context/ToolContext";
import { JoyrideWrapper } from "../../JoyrideWrapper";

export const SalesProduct = ({ end }) => {
	const {personalization_state} = useContext(ToolContext)
	const {walkthrough, startHere} = personalization_state
	const [firstStepReady, setFirstStepReady] = useState(false);

	const endTour = ()=>{
		walkthrough.set((p) => ({ ...p, salesProduct: false}))
		startHere.set((p) => ({ ...p, show: true}))
	}

	const steps = [
		{
			target: '.salesProductFirstStep',
			title: "Select Status",
			content: 'Select specific status.',
			disableBeacon: true,
			placement: "left",
		},
		{
			target: '.salesProductSecondStep',
			title: "Select Delivery Option",
			content: 'Filter by delivery option.',
			disableBeacon: true,
			placement: "left",
		},
		{
			target: '.salesProductThirdStep',
			title: "Select Start Date",
			content: 'The date you want to start the report.',
			disableBeacon: true,
			placement: "left",
		},
		{
			target: '.salesProductFourthStep',
			title: "Select End Date",
			content: 'Select the end date you want the report to show.',
			disableBeacon: true,
			placement: "left",
		},
		{
			target: '.salesProductFifthStep',
			title: "Generate Report",
			content: 'Click to generate the report.',
			disableBeacon: true,
			placement: "left",
		},
		{
			target: '.salesProductSixthStep',
			title: "Export In Excel",
			content: 'Click to download the report as excile file.',
			disableBeacon: true,
			placement: "left",
		},
	]

	useEffect(() => {
		const interval = setInterval(() => {
			const el = document.querySelector('.salesProductFirstStep');
			if (el) {
				clearInterval(interval);
				setFirstStepReady(true);
			}
		}, 100);
		return () => clearInterval(interval);
	}, []);

	return (
		firstStepReady && 
		<JoyrideWrapper 
			run={Boolean(walkthrough.data.salesProduct)} 
			steps={steps} 
			setter={endTour} 
			end={end}
			p_name="salesProduct" 
			featureName="reports"
		/>
	);
}
